<template>
  <CRow>
    <template v-if="!noCharts">
      <CCol md="3" sm="6" v-if="statInfo">
        <CWidgetBrand
          color="facebook"
          :right-header="pretest"
          right-footer="Pretest แล้ว"
          :left-header="posttest"
          left-footer="Posttest แล้ว"
        >
          <span
            height="52"
            class="iconify my-4"
            data-icon="mdi-chart-line"
            data-inline="false"
          ></span>
          <CChartLineSimple
            class="c-chart-brand"
            background-color="rgba(255,255,255,.1)"
            :data-points="[statInfo.pretest, statInfo.posttest]"
            label="Friends"
            labels="months"
          />
        </CWidgetBrand>
      </CCol>
      <div v-else class="spinner-border text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </template>
    <template v-else>
      <CCol md="3" sm="6">
        <CWidgetBrand
          color="facebook"
          right-header="89k"
          right-footer="friends"
          left-header="459"
          left-footer="feeds"
        >
          <CIcon name="cib-facebook" height="56" class="my-4" />
        </CWidgetBrand>
      </CCol>
      <CCol md="3" sm="6">
        <CWidgetBrand
          color="twitter"
          right-header="973k"
          right-footer="followers"
          left-header="1.792"
          left-footer="tweets"
        >
          <CIcon name="cib-twitter" height="56" class="my-4" />
        </CWidgetBrand>
      </CCol>
      <CCol md="3" sm="6">
        <CWidgetBrand
          color="linkedin"
          right-header="500+"
          right-footer="contracts"
          left-header="292"
          left-footer="feeds"
        >
          <CIcon name="cib-linkedin" height="56" class="my-4" />
        </CWidgetBrand>
      </CCol>
      <CCol md="3" sm="6">
        <CWidgetBrand
          right-header="12"
          right-footer="events"
          left-header="4"
          left-footer="meetings"
          color="warning"
        >
          <CIcon name="cil-calendar" height="56" class="my-4" />
        </CWidgetBrand>
      </CCol>
    </template>
  </CRow>
</template>

<script>
import { CChartLineSimple } from "../charts/index.js";

export default {
  name: "WidgetsBrand",
  components: {
    CChartLineSimple,
  },
  props: {
    noCharts: Boolean,
  },
  data() {
    return {
      statInfo: null,
      pretest:null,
      posttest:null
    };
  },
  mounted() {
    //FETCH ALL STAT
    this.axios
      .get(this.$hostUrl + "php_action/statAPI.php?txtAction=getAllStat")
      .then((response) => {
        this.statInfo = response.data.mainData;
        //console.log(this.provinceInfo);
        this.pretest = this.statInfo.pretest.toString();
        this.posttest = this.statInfo.posttest.toString();
      })
      .finally(() => {});
  },
};
</script>

<style scoped>
.c-chart-brand {
  position: absolute;
  width: 100%;
  height: 100px;
}
</style>
